import Choices from 'choices.js';
import "../../scss/components/_select.scss";

(function() {
  let selects = document.querySelectorAll('.selectable');
  
  selects.forEach(select => {
    new Choices(select, {
      silent: true,
      searchEnabled: false,
      shouldSort: false
    });
  });

  let multipleSelects = document.querySelectorAll('.selectable--multiple');

  multipleSelects.forEach(select => {
    new Choices(select, {
      searchEnabled: false,
      shouldSort: false,
      removeItems: true,
      removeItemButton: true
    });
  });
})();